export const shortcutGroups = [
  {
    key: "general",
    label: "General",
    shortcuts: [
      { id: "focus-search", binding: "/", keys: ["/"], label: "Focus search on the current page" },
      { id: "go-help", binding: "?", keys: ["?"], label: "Go to Help" },
      { id: "go-settings", binding: ";", keys: [";"], label: "Go to Settings" }
    ]
  }
];

export const shortcutsById = new Map(
  shortcutGroups.flatMap((group) => group.shortcuts.map((shortcut) => [shortcut.id, shortcut]))
);
